export default __webpack_public_path__ + "static/media/thumb-NDNU-4.ff3c12e9.png";